var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-details-dialog" },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            fullscreen: true,
            "close-on-press-escape": false,
            "show-close": false,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "replacement-request-title-bar",
              class: { "eligibility-check-step": _vm.isActive0 },
              attrs: { id: "replacement-request-title" },
            },
            [
              !_vm.showFinalStep
                ? _c(
                    "button",
                    {
                      staticClass: "el-dialog__headerbtn",
                      staticStyle: { right: "unset", left: "20px" },
                      attrs: { type: "button", "aria-label": "Back" },
                      on: { click: _vm.back },
                    },
                    [
                      _c("i", {
                        staticClass:
                          "el-dialog__close el-icon el-icon-arrow-left",
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "order-number" }, [
                _vm._v("\n        Replacement\n      "),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "el-dialog__headerbtn",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: { click: _vm.initiateClose },
                },
                [
                  _c("i", {
                    staticClass: "el-dialog__close el-icon el-icon-close",
                  }),
                ]
              ),
              _vm._v(" "),
              !_vm.isActive0
                ? _c("StepProgressBar", {
                    attrs: {
                      "total-steps": _vm.progressBarSteps,
                      "current-step": _vm.progressBarCurrentStep,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "div",
                {
                  staticClass: "replacement-request-body",
                  attrs: { id: "replacement-request-body" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "replacement-request-steps" },
                    [
                      _vm.eligibilityCheckEnabled
                        ? _c("StepFlowButton", {
                            attrs: {
                              buttontext: "Eligibility Check",
                              isactive: _vm.isActive0,
                              "current-value": 0,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("StepFlowButton", {
                        attrs: {
                          buttontext: "Step 1: Review customer details",
                          isactive: _vm.isActive1,
                          "current-value": 1,
                        },
                        on: { "go-back": _vm.previous },
                      }),
                      _vm._v(" "),
                      _vm.fulfillmentWarnActive
                        ? _c("StepFlowButton", {
                            attrs: {
                              buttontext: "Fulfillment Check",
                              isactive: _vm.isActive2,
                              "current-value": 2,
                            },
                            on: { "go-back": _vm.previous },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("StepFlowButton", {
                        attrs: {
                          buttontext: "Step 2: Select reason",
                          isactive: _vm.isActive3,
                          "current-value": 3,
                        },
                        on: { "go-back": _vm.previous },
                      }),
                      _vm._v(" "),
                      _c("StepFlowButton", {
                        attrs: {
                          buttontext: "Step 3: Choose replacement",
                          isactive: _vm.isActive4,
                          "current-value": 4,
                        },
                        on: { "go-back": _vm.previous },
                      }),
                      _vm._v(" "),
                      _c("StepFlowButton", {
                        attrs: {
                          buttontext: "Step 4: Submit replacement",
                          isactive: _vm.isActive5,
                          "current-value": 5,
                        },
                        on: { "go-back": _vm.previous },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { border: "1px solid #DEE5EC" } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "replacement-request-data",
                      attrs: { id: "replacement-request-data" },
                    },
                    [
                      _vm.currentStep === 0 && _vm.deviceOOWStatusVisible
                        ? _c("EligibilityCheck", {
                            attrs: {
                              device: _vm.device,
                              eligibility: _vm.eligibility,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("BypassReason", {
                        attrs: {
                          "v-if":
                            _vm.currentStep === 0 && _vm.bypassFormVisible,
                          "bypass-form-visible": _vm.bypassFormVisible,
                        },
                        on: {
                          "update:bypassFormVisible": function ($event) {
                            _vm.bypassFormVisible = $event
                          },
                          "update:bypass-form-visible": function ($event) {
                            _vm.bypassFormVisible = $event
                          },
                          "set-bypass-reason": _vm.setBypassReason,
                        },
                      }),
                      _vm._v(" "),
                      _vm.currentStep === 1 && !_vm.isEditDetailsStep
                        ? _c("ReviewCustomerDetailsAddress", {
                            attrs: {
                              loading: _vm.loadingAddress,
                              "edit-details": _vm.isEditDetailsStep,
                              filled: _vm.customerDetailsFilled,
                              customer: _vm.customerDetails,
                              address: _vm.customerAddress,
                            },
                            on: {
                              "update:editDetails": function ($event) {
                                _vm.isEditDetailsStep = $event
                              },
                              "update:edit-details": function ($event) {
                                _vm.isEditDetailsStep = $event
                              },
                              "update:filled": function ($event) {
                                _vm.customerDetailsFilled = $event
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep === 1 && !_vm.isEditDetailsStep
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "expedited-shipping-option flex flex-auto flex-col",
                            },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(
                                  "\n            Shipping Options\n          "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-card",
                                {
                                  staticStyle: { width: "20rem" },
                                  attrs: { shadow: "never" },
                                },
                                [
                                  _c("ExpeditedFormButton", {
                                    attrs: {
                                      expedited: _vm.shippingOptions.expedited,
                                    },
                                    on: {
                                      "update:expedited": function ($event) {
                                        return _vm.$set(
                                          _vm.shippingOptions,
                                          "expedited",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep === 1 && _vm.isEditDetailsStep
                        ? _c("EditCustomerDetail", {
                            ref: "editCustomer",
                            attrs: {
                              allvalid: _vm.editCustomerEnableSave,
                              customer: _vm.customerDetails,
                              address: _vm.customerAddress,
                            },
                            on: {
                              "update:allvalid": function ($event) {
                                _vm.editCustomerEnableSave = $event
                              },
                              "update:customer": function ($event) {
                                _vm.customerDetails = $event
                              },
                              "update:address": function ($event) {
                                _vm.customerAddress = $event
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep === 2
                        ? _c("FulfillmentCheck", {
                            model: {
                              value: _vm.bypassFulfillment,
                              callback: function ($$v) {
                                _vm.bypassFulfillment = $$v
                              },
                              expression: "bypassFulfillment",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep === 3
                        ? _c("ReplacementReasons", {
                            attrs: {
                              device: _vm.device,
                              loading: _vm.loading,
                              "selected-group": _vm.selectedReasons.group,
                              "selected-reason": _vm.selectedReasons.reason,
                            },
                            on: {
                              "update:loading": function ($event) {
                                _vm.loading = $event
                              },
                              "selected-group-and-reason":
                                _vm.getSelectedReasons,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep === 4
                        ? _c("ChooseReplacement", {
                            attrs: {
                              device: _vm.device,
                              "is-supervisor": _vm.isSupervisor,
                              "selected-value": _vm.selectedValue,
                              skus: _vm.availableReplacements,
                              "best-match": _vm.bestMatch,
                              expedited: _vm.shippingOptions.expedited,
                              country: _vm.customerAddress.country,
                              state: _vm.customerAddress.state,
                              "replacement-search": _vm.replacementSearch,
                            },
                            on: {
                              "set-replacement-search":
                                _vm.setReplacementSearch,
                              "set-selected-options": _vm.setSelectedOption,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep === 5 && !_vm.showFinalStep
                        ? _c("ReviewReplacementSummary", {
                            attrs: {
                              loading: _vm.loading,
                              device: _vm.device,
                              "replacement-product": _vm.selectedValue,
                              "selected-name": _vm.selectedReasons.name,
                              customer: _vm.customerDetails,
                              "first-setup-date": _vm.firstSetupDate,
                              address: _vm.customerAddress,
                            },
                            on: {
                              "update:loading": function ($event) {
                                _vm.loading = $event
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep === 5 && _vm.showFinalStep
                        ? _c("ReplacementSummary", {
                            attrs: {
                              loading: _vm.loading,
                              device: _vm.device,
                              "replacement-product": _vm.selectedValue,
                              "selected-name": _vm.selectedReasons.name,
                              customer: _vm.customerDetails,
                              address: _vm.customerAddress,
                              "first-setup-date": _vm.firstSetupDate,
                              "replacement-id": _vm.replacementId,
                              "created-on": _vm.createdOn,
                              "needs-return-label": _vm.needsReturnLabel,
                            },
                            on: {
                              "update:loading": function ($event) {
                                _vm.loading = $event
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "replacement-request-footer",
              attrs: { id: "replacement-request-footer" },
            },
            [
              _c(
                "el-checkbox",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showReturnSummaryConfirmationLink,
                      expression: "showReturnSummaryConfirmationLink",
                    },
                  ],
                  staticClass: "confirm-checkbox",
                  staticStyle: { "margin-right": "24px" },
                  model: {
                    value: _vm.isSummaryConfirmed,
                    callback: function ($$v) {
                      _vm.isSummaryConfirmed = $$v
                    },
                    expression: "isSummaryConfirmed",
                  },
                },
                [
                  _vm._v(
                    "\n        The items for return and address are correct.\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.showAddressConfirmationCheck
                ? _c(
                    "el-checkbox",
                    {
                      staticClass: "confirm-checkbox",
                      staticStyle: { "margin-right": "24px" },
                      model: {
                        value: _vm.isConfirmed,
                        callback: function ($$v) {
                          _vm.isConfirmed = $$v
                        },
                        expression: "isConfirmed",
                      },
                    },
                    [
                      _vm._v(
                        "\n        Customer details and address are correct.\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showExit,
                      expression: "showExit",
                    },
                  ],
                  staticClass: "action_button",
                  on: { click: _vm.initiateClose },
                },
                [_vm._v("\n        Exit\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.deviceOOWStatusVisible,
                      expression: "deviceOOWStatusVisible",
                    },
                  ],
                  staticClass: "action_button back",
                  attrs: { type: "primary" },
                  on: { click: _vm.allowToBypass },
                },
                [_vm._v("\n        Bypass\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showCancel,
                      expression: "showCancel",
                    },
                  ],
                  staticClass: "action_button back",
                  staticStyle: {
                    color: "#1998d5 !important",
                    "margin-right": "2px",
                  },
                  on: { click: _vm.cancel },
                },
                [_vm._v("\n        Cancel\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showSaveChanges,
                      expression: "showSaveChanges",
                    },
                  ],
                  staticClass: "action_button",
                  attrs: {
                    type: "primary",
                    disabled:
                      !_vm.editCustomerEnableSave && !_vm.customerDetailsFilled,
                  },
                  on: { click: _vm.saveChanges },
                },
                [_vm._v("\n        Save Changes\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showBack,
                      expression: "showBack",
                    },
                  ],
                  staticClass: "action_button back",
                  on: { click: _vm.back },
                },
                [_vm._v("\n        Back\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showNext,
                      expression: "showNext",
                    },
                  ],
                  staticClass: "action_button",
                  attrs: { type: "primary", disabled: _vm.isNextDisabled },
                  on: { click: _vm.next },
                },
                [_vm._v("\n        Continue\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === 5 && !_vm.showFinalStep,
                      expression: "currentStep === 5 && !showFinalStep",
                    },
                  ],
                  staticClass: "action_button",
                  attrs: {
                    type: "primary",
                    disabled: _vm.isSendReplacementLabelDisabled,
                  },
                  on: { click: _vm.finalStep },
                },
                [_vm._v("\n        Submit Replacement\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === 5 && _vm.showFinalStep,
                      expression: "currentStep === 5 && showFinalStep",
                    },
                  ],
                  staticClass: "action_button",
                  attrs: { type: "primary" },
                  on: { click: _vm.exit },
                },
                [_vm._v("\n        Done\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.exitModalVisible
            ? _c("ExitModal", {
                attrs: { visible: _vm.exitModalVisible },
                on: {
                  "update:visible": function ($event) {
                    _vm.exitModalVisible = $event
                  },
                  "exit-replacement": _vm.confirmClose,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }